import { UserRole } from '@shared/types/user';
import { MenuItem } from './menu-item.type';

export const HUB_MENU_ITEMS: MenuItem[] = [
  {
    name: 'header.client',
    url: '/client',
    icon: 'Gear',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.games',
    url: '/hub-games',
    icon: 'Games',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.users',
    url: '/users',
    icon: 'Users',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.campaigns',
    url: '/campaigns',
    icon: 'Radio',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.actions',
    url: '/actions',
    icon: 'List',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.labels',
    url: '/labels',
    icon: 'Language',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.assets',
    url: '/assets',
    icon: 'Upload',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.theme',
    url: '/hub-theme',
    icon: 'Droplet',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.tokenValidation',
    url: '/token-validation',
    icon: 'Security',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
    ],
  },
  {
    name: 'header.tasks',
    url: '/tasks',
    icon: 'Tasks',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.preview',
    url: '/preview',
    icon: 'Eye',
    permission: [UserRole.Admin],
  },
];
